export default __webpack_public_path__ + "static/media/emoji-france.1a37dc9d.svg";